import { loadCapacityCounts, getAdmissionItemCapacityids, getRegTypeCapacityIds,
  getAllSessionCapacityIds, getQuantityItemCapacityIds } from 'event-widgets/redux/modules/capacity';
import { getRegPackId } from '../selectors/shared';

const collectAllCapacityIdsFromStore = (event, regPackId) => {
  const regTypeCapacityIds = getRegTypeCapacityIds(event, null, regPackId);
  const sessionCapacityIds = getAllSessionCapacityIds(event);
  const admissionCapacityIds = getAdmissionItemCapacityids(event);
  const quantityItemCapacityIds = getQuantityItemCapacityIds(event);
  const eventCapacityId = event.capacityId;
  return [...sessionCapacityIds, ...admissionCapacityIds, ...eventCapacityId,
    ...regTypeCapacityIds, ...quantityItemCapacityIds];
};

export const fetchCapacitySummaries =
  async (regCartClient, capacityClient, accessToken, regCartId, capacityIds, hasSessionInitialized) => {
    // If regCartId is present, call the regAPI capacity endpoint, otherwise just call capacity service directly
    let capacity = null;
    if (regCartId && hasSessionInitialized) {
      capacity = regCartClient.getCapacitySummaries(accessToken, regCartId, capacityIds);
    } else if (regCartId && !hasSessionInitialized) {
      capacity = regCartClient.getCapacitySummariesOnPageLoad(accessToken, regCartId, capacityIds);
    } else {
      capacity = capacityClient.getCapacitySummaries(accessToken, capacityIds);
    }
    return capacity;
  };

export const loadAvailableCapacityCounts = () => {
  return async (dispatch, getState) => {
    const { accessToken, event, clients: { regCartClient, capacityClient }, userSession } = getState();
    const capacityIds = collectAllCapacityIdsFromStore(event, getRegPackId(getState()));
    const regCartId = userSession && userSession.regCartId;
    dispatch(loadCapacityCounts(
      await fetchCapacitySummaries(regCartClient, capacityClient, accessToken, regCartId, capacityIds, true)
    ));
  };
};
